module.exports = __webpack_public_path__ + "static/media/lato-v15-latin-700.fe7d53e4.ttf";